export enum BuilderQuoteStatus {
  CREATED = "Created",
  CONFIRMED = "Confirmed",
  READY = "Ready",
}
